import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage } from '../MovingBlockSlice';
import TruckAnimation from '../Partials/TruckAnimation/TruckAnimation';

const TruckAnimationPage = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <TruckAnimation />
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        page: state.movingBlock.page,

    };
};

const mapDispatchToProps = { goToPage };

export default connect(mapStateToProps, mapDispatchToProps)(TruckAnimationPage);